<template>
    <dynamicSelectVue
        ref="dynamicSelect"
        title="Número de cuenta bancaria"
        :estados="data"
        show="numero"
        item-value="id"
        v-model="id"
        outlined
        @create="save"
        @delete="destroy"
        @getEstado="getById"
        @update="save"
        @changeElement="change"
    >
        <v-form ref="form" v-model="validForm">
            <v-row class="mt-3">
                <v-col cols="12">
                    <v-text-field
                        outlined
                        v-model="selectedItem.numero"
                        label="Número de cuenta / IBAN"
                        :rules="[rules.required]"
                        dense
                    ></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        outlined
                        v-model="selectedItem.nombre"
                        label="Entidad bancaria (opcional)"
                        dense
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-form>
    </dynamicSelectVue>
</template>
<script>
import dynamicSelectVue from "./dynamicSelect.vue";
import { rules } from "../../rules";
export default {
    name: "CuentasBancariasSelect",
    components: {
        dynamicSelectVue,
    },
    props: {
        value: {
            type: [Number, String],
            required: false,
            default: null,
        },
    },
    data() {
        return {
            validForm: true,
            rules: rules,
            id: null,
            data: [],
            selectedItem: {
                id: null,
                numero: "",
                nombre: "",
            },
        };
    },
    created() {
        this.id = this.value;
    },
    mounted() {
        this.index();
    },
    watch: {
        value(val) {
            this.id = val;
        },
        id(val) {
            this.$emit("input", val);
            const cuenta = val != null ? this.data.find((c) => c.id == val) : null;
            this.$emit("cuenta-selected", cuenta);
        },
    },
    methods: {
        index() {
            axios.get("api/cuentas-bancarias").then((res) => {
                this.data = res.data.cuentas;
                if (this.id != null) {
                    const cuenta = this.data.find((c) => c.id == this.id);
                    this.$emit("cuenta-selected", cuenta || null);
                }
            });
        },

        save() {
            this.$refs.form.validate();
            if (!this.validForm) return;

            if (this.selectedItem.id != null) {
                axios
                    .put(
                        `api/cuentas-bancarias/${this.selectedItem.id}`,
                        this.selectedItem
                    )
                    .then((res) => {
                        this.$refs.dynamicSelect.closeDialog();
                        this.$toast.sucs(
                            res.data.message ||
                                "Cuenta bancaria actualizada con éxito"
                        );
                        this.clearSelectedItem();
                        this.index();
                    })
                    .catch((error) => {
                        const msg =
                            error.response?.data?.mensaje ||
                            error.response?.data?.error ||
                            (error.response?.status == 400
                                ? "Error al actualizar"
                                : "Error procesando la solicitud");
                        this.$custom_error(msg);
                    });
            } else {
                axios
                    .post("api/cuentas-bancarias", this.selectedItem)
                    .then((res) => {
                        this.$refs.dynamicSelect.closeDialog();
                        this.$toast.sucs(
                            res.data.message ||
                                "Cuenta bancaria creada con éxito"
                        );
                        this.clearSelectedItem();
                        this.index();
                    })
                    .catch((error) => {
                        const msg =
                            error.response?.data?.mensaje ||
                            error.response?.data?.error ||
                            (error.response?.status == 400
                                ? "Error al guardar"
                                : "Error procesando la solicitud");
                        this.$custom_error(msg);
                    });
            }
        },
        destroy(id) {
            axios
                .delete(`api/cuentas-bancarias/${id}`)
                .then((res) => {
                    this.$toast.sucs(
                        res.data.message ||
                            "Cuenta bancaria eliminada con éxito"
                    );
                    this.index();
                    this.clearSelectedItem();
                })
                .catch((error) => {
                    if (error.response?.status == 400) {
                        this.$custom_error(error.response.data.mensaje);
                    } else {
                        this.$custom_error("Error procesando la solicitud");
                    }
                });
        },
        getById(id) {
            if (id != null) {
                axios
                    .get(`api/cuentas-bancarias/${id}`)
                    .then((res) => {
                        this.selectedItem = res.data.data;
                    })
                    .catch((error) => {
                        if (error.response?.code == 400) {
                            this.$custom_error(error.response.data.mensaje);
                        } else {
                            this.$custom_error("Error procesando la solicitud");
                        }
                    });
            }
        },
        change(id) {
            this.$refs.dynamicSelect.closeDialog();
        },
        clearSelectedItem() {
            this.selectedItem = {
                id: null,
                numero: "",
                nombre: "",
            };
        },
    },
};
</script>
